import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { useMedicationsStore } from "../stores/medicationsStore";
import type { Hint } from "../types";

const MEDICATIONS_QUERY_KEY = ["medications"] as const;
const MEDICATIONS_URL = "/data/medications.json";

type MedicationsResponse = {
  terms: Hint[];
};

export const useMedications = () => {
  const setMedications = useMedicationsStore((s) => s.setMedications);

  const query = useQuery<MedicationsResponse>({
    queryKey: MEDICATIONS_QUERY_KEY,
    queryFn: async () => {
      const response = await fetch(MEDICATIONS_URL);
      if (!response.ok) {
        throw new Error(`Failed to fetch medications: ${response.status}`);
      }
      return response.json() as Promise<MedicationsResponse>;
    },
    staleTime: Infinity,
    gcTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });

  useEffect(() => {
    if (query.data?.terms) {
      setMedications(query.data.terms);
    }
  }, [query.data, setMedications]);

  return query;
};
